<div class="version-dialog-container">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h3 class="dialog-title">{{getDialogTitle()}}</h3>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Form Content -->
  <div class="form-container">
    <!-- Loading Overlay -->
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-icon class="loading-spinner">refresh</mat-icon>
      <span>Loading folder details...</span>
    </div>

    <form [formGroup]="versionForm" (ngSubmit)="onSave()">
      <div class="form-content">
        <!-- Date Field -->
        <div class="form-row">
          <label class="form-label">Date</label>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput type="datetime-local" formControlName="date" placeholder="2025-11-24 11:50:49">
            <mat-error *ngIf="versionForm.get('date')?.hasError('required')">
              Date is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Folder Field -->
        <div class="form-row">
          <label class="form-label">Folder</label>
          <div class="folder-input-container">
            <mat-form-field appearance="outline" class="folder-field">
              <input matInput formControlName="folder" placeholder="Folder path">
              <mat-error *ngIf="versionForm.get('folder')?.hasError('required')">
                Folder path is required
              </mat-error>
            </mat-form-field>
            @if (!isEdit) {
            <button mat-raised-button type="button" color="primary" (click)="onLookup()" class="lookup-button">
              Lookup
            </button>
            }
          </div>
        </div>

        <!-- Version Field -->
        <div class="form-row">
          <label class="form-label">Version</label>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="version" placeholder="xx.yy.zz" pattern="^\d+\.\d+\.\d+$">
            <mat-error *ngIf="versionForm.get('version')?.hasError('required')">
              Version is required
            </mat-error>
            <mat-error *ngIf="versionForm.get('version')?.hasError('pattern')">
              Version format should be x.y.z (e.g., 1.2.3)
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Description Field -->
        <div class="form-row">
          <label class="form-label">Description</label>
          <mat-form-field appearance="outline" class="form-field">
            <textarea matInput formControlName="description" rows="3" placeholder="Version description">
          </textarea>
          </mat-form-field>
        </div>

        <!-- Published Checkbox -->
        <div class="form-row checkbox-row">
          <div>
            <label class="form-label">Published</label>
            <mat-checkbox formControlName="published" class="form-checkbox">
            </mat-checkbox>
          </div>
          <!-- Critical Checkbox -->
          <div class="critical">
            <label class="form-label">Critical</label>
            <mat-checkbox formControlName="critical" class="form-checkbox">
            </mat-checkbox>
          </div>
        </div>
      </div>
    </form>
    <!-- Lookup Message -->
    <div class="" *ngIf="lookupMessage">
      <label class="form-label"></label>
      <div class="lookup-message" [ngClass]="{'success-message': lookupSuccess, 'error-message': !lookupSuccess}">
        {{ lookupMessage }}
      </div>
    </div>
  </div>

  <!-- <div class="form-row checkbox-row">

  </div> -->

  <!-- Dialog Actions -->
  <div class="dialog-actions">
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="versionForm.invalid || isAlreadySaved">
      Save
    </button>
    <button mat-button (click)="onClose()">Close</button>
  </div>
</div>